export enum SortFields {
  ROLE = 'role',
  NAME = 'username',
  EMAIL = 'email',
  NEED_HELP = 'need_help',
  LAST_LOGIN = 'last_online',
  ORGANIZATION_NAME = 'organization_name',
}

export enum SortType {
  ASC = 'asc',
  DESC = 'desc',
}

export enum SortOptions {
  NAME = 'name',
  UPDATED_AT = 'updated_at',
  CREATED_AT = 'created_at',
  LAST_VIEWED = 'recent_views',
  SIZE = 'size',
  OWNER = 'owner',
  ORIGINS = 'origins',
}
